export default "__VITE_ASSET__D6oQl_gR__"